import { render, staticRenderFns } from "./goods_name.vue?vue&type=template&id=5f2a75a3&scoped=true"
import script from "./goods_name.vue?vue&type=script&lang=js"
export * from "./goods_name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2a75a3",
  null
  
)

export default component.exports